import { render, staticRenderFns } from "./NftEdit.vue?vue&type=template&id=0a72e672&scoped=true&"
import script from "./NftEdit.vue?vue&type=script&lang=js&"
export * from "./NftEdit.vue?vue&type=script&lang=js&"
import style0 from "./NftEdit.vue?vue&type=style&index=0&id=0a72e672&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a72e672",
  null
  
)

export default component.exports